import $ from 'jquery'
$(function() {
  $('.thumbnail-sortable').sortable({
    placeholderClass: 'col-12'
  });  
});